import { OmnitagResultItem } from 'packages/lib/api/omnitag/contract/omnitag-search';

export interface DistributionData {
  label: string;
  shortLabel: string;
  count: number;
}

export type MetadataField = keyof Pick<
  OmnitagResultItem,
  | 'city'
  | 'route_name'
  | 'sun_lighting_condition'
  | 'weather_condition'
  | 'channel'
>;

export interface ChartConfig {
  field: MetadataField;
  title: string;
  colorIndex: number;
}

export const ALL_CHARTS: ChartConfig[] = [
  { field: 'sun_lighting_condition', title: 'Lighting', colorIndex: 0 },
  { field: 'weather_condition', title: 'Weather', colorIndex: 1 },
  { field: 'city', title: 'City', colorIndex: 2 },
  { field: 'channel', title: 'Camera', colorIndex: 3 },
  { field: 'route_name', title: 'Route', colorIndex: 4 },
];

export const DEFAULT_FIELDS = new Set<MetadataField>([
  'city',
  'sun_lighting_condition',
  'weather_condition',
]);

const MAX_BARS = 5;

export function abbreviateLabel(label: string, field: MetadataField): string {
  if (field === 'channel') {
    return label.replace('CAM_', '');
  }
  if (field === 'sun_lighting_condition' || field === 'city') {
    label = label.charAt(0).toUpperCase() + label.slice(1);
  }
  if (label.length > 8) {
    return label.slice(0, 7) + '…';
  }
  return label;
}

export function computeDistribution(
  items: OmnitagResultItem[],
  field: MetadataField
): { data: DistributionData[]; overflow: number } {
  const counts = new Map<string, number>();
  for (const item of items) {
    const value = item[field] || 'Unknown';
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  const sorted = Array.from(counts.entries())
    .map(([label, count]) => ({
      label,
      shortLabel: abbreviateLabel(label, field),
      count,
    }))
    .sort((a, b) => b.count - a.count);

  const overflow = Math.max(0, sorted.length - MAX_BARS);
  return { data: sorted.slice(0, MAX_BARS), overflow };
}
